export const generateCouponCode = price => {
	if (price > 0) {
		return Math.random().toString(36).substring(2, 12).toUpperCase();
	} else {
		return '';
	}
}
